import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get reciptVoucher
export const getReciptVoucher = createAsyncThunk(
  "reciptVoucher/getReciptVoucher",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getReciptVoucher({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all reciptVoucher
export const getAllReciptVoucher = createAsyncThunk(
  "reciptVoucher/getAllReciptVoucher",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllReciptVoucher();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("reciptVoucher/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("reciptVoucher/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "reciptVoucher/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageReciptVoucher({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getReciptVoucherById = createAsyncThunk(
  "reciptVoucher/getReciptVoucherById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getReciptVoucherById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create reciptVoucher
export const createReciptVoucher = createAsyncThunk(
  "reciptVoucher/createReciptVoucher",
  async (createData, { rejectWithValue }) => {
    const {
      voucherType,
      voucherDetails,
      reference,
      date,
      narration,
      reciptVoucherDate,
      reciptVoucherDateBs,
      reciptVoucherType,
    } = createData;
    try {
      const body = JSON.stringify({
        voucherType,
        voucherDetails,
        reference,
        date,
        narration,
        reciptVoucherDate,
        reciptVoucherDateBs,
        reciptVoucherType,
      });

      const { data } = await API.createReciptVoucher(body);

      //     // const

      // for (const detail of costCenterDetails) {
      //   await API.createCostCenterDetails(JSON.stringify(detail));
      // }
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const updateReciptVoucher = createAsyncThunk(
  "reciptVoucher/updateReciptVoucher",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const {
      reciptVoucherDetails,
      reference,
      date,
      narration,
      reciptVoucherDate,
      reciptVoucherDateBs,
      reciptVoucherType,
    } = values;
    try {
      const body = JSON.stringify({
        reciptVoucherDetails,
        reference,
        date,
        narration,
        reciptVoucherDate,
        reciptVoucherDateBs,
        reciptVoucherType,
      });
      const { data } = await API.updateReciptVoucher(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const approveReciptVoucher = createAsyncThunk(
  "reciptVoucher/approveReciptVoucher",
  async (id, { rejectWithValue }) => {
    try {
      const body = JSON.stringify({
        approved: true,
      });
      const { data } = await API.approveReciptVoucher(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "reciptVoucher/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
